module.exports = __webpack_public_path__ + "media/images/applicant/polygon-blue-50be5dbbca3624cb0fd1074d7f673222.svg";